module.exports = __webpack_public_path__ + "img/img_app_3.3c386d78.jpg";